import clsx from 'clsx';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { memo } from 'react';

import type { UefatvEditorialContent } from '@shared-types/uefatv.types';
import { AccessLevel } from '@shared-types/uefatv.types';

import * as styles from './styles.module.scss';

dayjs.extend(duration);
const CardOverlay = ({ item, isHovered = false }: { item: UefatvEditorialContent; isHovered?: boolean }) => {
  if (!item) {
    return null;
  }
  return (
    <div
      className={clsx('pk-text--text-04', {
        [styles.cardOverlay]: true,
        [styles.visible]: isHovered,
      })}
    >
      <div className='main'>
        <h3 className='pk-font--base-semibold pk-font-size--s'>{item.title}</h3>
        <p className='pk-font--base-regular pk-font-size--xs'>{item?.description}</p>
      </div>
      <div className={styles.footer}>
        {!!item?.duration && (
          <>
            <div className={styles.duration}>{dayjs.duration(item.duration, 's').format('mm:ss')}</div>
            {item.accessLevel !== AccessLevel.GRANTED && <div className={styles.signIn}>Log in to watch</div>}
          </>
        )}
      </div>
    </div>
  );
};

export default memo(CardOverlay);
